import { Fab, Icon, Slide, Tooltip } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import { t } from "i18next";
/**
 * Floating action menu for adding, removing and removing charts.
 * @param {*} param0
 * @returns
 */
const FloatingActionsMenu = ({
	edit,
	onClick = () => {},
	handleAddChart = () => {},
	handleImportChart = () => {},
	handleGenerateChart = () => {}
}) => {
	/**
	 * Edition menu for a potential update
	 * */
	if (edit) {
		return (
			<MDBox
				style={{
					position: "fixed",
					bottom: 20,
					right: 20,
					zIndex: 1000,
					gap: "1rem"
				}}
				display="flex"
				flexDirection="column"
			>
				<Slide direction="up" in={edit} style={{ transformOrigin: "bottom" }}>
					<Tooltip title={t("SETTINGS.CHARTS.addChartFromCatalogFAB")} placement="left" arrow>
						<Fab size="medium" color="info" onClick={() => handleImportChart()}>
							<Icon fontSize="small">library_add</Icon>
						</Fab>
					</Tooltip>
				</Slide>
				<Slide direction="up" in={edit} style={{ transformOrigin: "bottom" }}>
					<Tooltip title={t("SETTINGS.CHARTS.addChartFAB")} placement="left" arrow>
						<Fab size="medium" color="info" onClick={() => handleAddChart()}>
							<Icon fontSize="small">add_chart</Icon>
						</Fab>
					</Tooltip>
				</Slide>
				<Slide direction="up" in={edit} style={{ transformOrigin: "bottom" }}>
					<Tooltip title={t("SETTINGS.CHARTS.addChartAI")} placement="left" arrow>
						<Fab size="medium" color="info" onClick={() => handleGenerateChart()}>
							<Icon fontSize="small">auto_awesome</Icon>
						</Fab>
					</Tooltip>
				</Slide>
				<Tooltip title={t("SETTINGS.CHARTS.closeFAB")} placement="left" arrow>
					<Fab size="medium" color="light" onClick={onClick}>
						<Icon fontSize="small">close</Icon>
					</Fab>
				</Tooltip>
			</MDBox>
		);
	} else {
		return (
			<Tooltip title={t("SETTINGS.CHARTS.openFAB")} placement="left" arrow>
				<MDBox
					style={{
						position: "fixed",
						bottom: 20,
						right: 20,
						zIndex: 1000
					}}
				>
					<Fab size="medium" color="info" onClick={onClick}>
						<Icon fontSize="small">edit</Icon>
					</Fab>
				</MDBox>
			</Tooltip>
		);
	}
};

export default FloatingActionsMenu;
